// Shared in-call control bar for the caller (CallView) and the staff softphone
// (StaffCallView). Uses the universally-recognized video-call icons (microphone /
// camera / flip / red phone-down) from the app's single icon set (icons.tsx), with
// NO visible text — so the controls are language-agnostic (contact-center agents in
// any language understand them, same as Zoom/Meet/WhatsApp). On/off state is shown
// by a slashed icon on a red button. aria-label is kept for screen readers only
// (localised via the i18n dictionary).
import { t } from '../i18n'
import { CameraIcon, CameraOffIcon, FlipCameraIcon, HangUpIcon, MicIcon, MicOffIcon } from './icons'

interface Props {
  micOn: boolean
  videoOn: boolean
  canSwitchCam: boolean
  visible: boolean
  onToggleMic: () => void
  onToggleVideo: () => void
  onSwitchCam: () => void
  onHangup: () => void
  poke: () => void
}

const CallControls = ({ micOn, videoOn, canSwitchCam, visible, onToggleMic, onToggleVideo, onSwitchCam, onHangup, poke }: Props) => {
  const tap = (fn: () => void, repoke = true) => (e: React.MouseEvent) => {
    e.stopPropagation()
    fn()
    if (repoke) poke()
  }
  return (
    <div className={`cf-controls ${visible ? '' : 'hidden'}`}>
      <button className={`cf-ctrl ${micOn ? '' : 'off'}`} onClick={tap(onToggleMic)}
              aria-label={micOn ? t.muteMic : t.unmuteMic}>
        {micOn ? <MicIcon /> : <MicOffIcon />}
      </button>
      <button className={`cf-ctrl ${videoOn ? '' : 'off'}`} onClick={tap(onToggleVideo)}
              aria-label={videoOn ? t.turnOffCamera : t.turnOnCamera}>
        {videoOn ? <CameraIcon /> : <CameraOffIcon />}
      </button>
      {canSwitchCam && (
        <button className="cf-ctrl" onClick={tap(onSwitchCam)} aria-label={t.switchCamera}>
          <FlipCameraIcon />
        </button>
      )}
      <button className="cf-ctrl hangup" onClick={tap(onHangup, false)} aria-label={t.hangUp}>
        <HangUpIcon />
      </button>
    </div>
  )
}

export default CallControls
